import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable()
export class ApiKeyInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // Verifica se a requisição é para a API base.
    // Usa startsWith para evitar falsos positivos com paths relativos (ex.: '/dev').
    const isApiRequest = req.url.startsWith(environment.apiBaseUrl);

    // Se for requisição para a API e existe API key configurada, adiciona o header
    if (isApiRequest && environment.apiKey) {
      const clonedRequest = req.clone({
        setHeaders: {
          'x-api-key': environment.apiKey,
        },
      });

      return next.handle(clonedRequest);
    }

    // Caso contrário, continua sem modificar nada
    return next.handle(req);
  }
}
